import { NodeType } from './NodeType'

export const isTextNode = (node: Node): node is Text =>
    node.nodeType === NodeType.Text
